export default __webpack_public_path__ + "static/media/coreos-icon.d61e1625.svg";